import React, { useState, useEffect } from "react";
import ProductGrid from "./ProductGrid";
import useApi from "../../../../utils/api-manager/Helper/useApi";

const ProductList = ({ addProductToContainer, handleCreateInvoice, onQuantityBlockClick, onPriceBlockClick }) => {
  const [blocksData, setBlocksData] = useState(
    Array(49).fill(null).map(() => ({ title: "", price: 0, colour: "", isSet: false }))
  );
  const { Get } = useApi();

  useEffect(() => {
    fetchProductData();
  }, []);

  const fetchProductData = async () => {
    try {
      const response = await Get(`posItem`);
      if (response) {
        const sortedResults = response.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
        const newBlocks = Array(49).fill(null).map((_, index) => ({
          title: "", price: 0, colour: "", index, isSet: false
        }));
        const filledIndices = new Set();
        sortedResults.forEach((item) => {
          const index = parseInt(item.index);
          if (!isNaN(index) && index >= 0 && index < 49 && !filledIndices.has(index)) {
            newBlocks[index] = {
              id: item.id,
              title: item.title,
              price: item.price,
              colour: item.color || item.colour,
              index,
              isSet: true,
              updatedAt: item.updated_at
            };
            filledIndices.add(index);
          }
        });
        setBlocksData(newBlocks);
      }
    } catch (error) {
      console.error("Error fetching POS items:", error);
    }
  };

  const handleItemClick = (block) => {
    if (block?.isSet) addProductToContainer(block);
  };

  const handleSpecialBlockClick = (blockIndex) => {
    if (blockIndex === 42) onQuantityBlockClick();
    else if (blockIndex === 43) onPriceBlockClick();
  };

  return (
    <div className="container-fluid h-100 p-0">
      <ProductGrid
        blocksData={blocksData}
        handleItemClick={handleItemClick}
        handleSaveClick={handleCreateInvoice}
        handleSpecialBlockClick={handleSpecialBlockClick}
      />
    </div>
  );
};

export default ProductList;
